<template>
  <div class="creatorConnections">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-pinpai"></use>
      </svg>
    </breadcrumbs>
    <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" :disabled="load" @change="onTabChange" />
    <div class="container" v-if="activeTab == '0'||activeTab == '1'||activeTab == '2'">
      <div class="search" v-if="activeTab == '0'||activeTab == '1'||activeTab == '2'">
        <div class="search-left">
          <a-space v-if="activeTab == '0'||activeTab == '1'">
            <span style="margin-right: 8px">Amazon Seller Name:</span>
            <a-input-search style="width: 180px" v-model:value="params.sellerName" placeholder="Search..." allow-clear
              @search="onSearchSellerName" @enter="onSearchSellerName">
            </a-input-search>
          </a-space>
          <a-space v-if="activeTab == '0'||activeTab == '1'">
            <span style="margin-right: 8px">Amazon Profile Name:</span>
            <a-input-search style="width: 180px" v-model:value="params.amazonProfileAccountInfoName"
              placeholder="Search..." allow-clear @search="onSearchProfileName" @enter="onSearchProfileName">
            </a-input-search>
          </a-space>
          <a-space v-if="activeTab == '0'||activeTab == '1'">
            <span style="margin-right: 8px">Status:</span>
            <a-select v-model:value="params.status" placeholder="Select Status" style="width: 160px">
              <a-select-option value="">all</a-select-option>
              <a-select-option value="pending">pending</a-select-option>
              <!-- <a-select-option value="accepted">accepted</a-select-option> -->
              <a-select-option value="authorized">authorized</a-select-option>
              <!-- <a-select-option value="revoked">revoked</a-select-option> -->
            </a-select>
          </a-space>
          <a-space v-if="activeTab == '1'|activeTab == '2'">
            <span style="margin-right: 8px">brands:</span>
            <a-input-search style="width: 180px" v-model:value="params.brandName"
              placeholder="Search..." allow-clear @search="onSearchProfileName" @enter="onSearchProfileName">
            </a-input-search>
          </a-space>
        </div>
      </div>
      <div class="search-right" v-if="activeTab == '0'||activeTab == '1'||activeTab == '2'">
        <a-button type="primary" @click="refreshAll" v-if="activeTab == '1'">全部更新</a-button>
        <a-button type="primary" @click="onSearch">Search</a-button>
        <artmisads-select-button @click="onReset" size="middle" :isSquare="true">Reset</artmisads-select-button>
      </div>
      <div class="table-container">
        <artmisads-table ref="tableRef" :columns="columns" :dataSource="dataList" :pagination="pagination"
          :loading="load" :rowKey="(record) => record.id" :change="onChangePage" :scroll="{ x:activeTab == '2' ? 2200 : 1600 }">
          <template #bodyCell="{ column, record, text }">
            <template v-if="column.name == 'artemisAdsAccount' && activeTab == '0'">
              <div class="seller-name">
                {{ record.sellerName }}
              </div>
              <div class="seller-email">
                {{ record.sellerEmail }}
              </div>
            </template>
            <template v-if="column.name == 'artemisAdsAccount' && (activeTab == '1')">
              {{ record.sellerName }}
            </template>
            <template v-if="column.name == 'amazonProfileName' && activeTab == '0'">
              {{
                returnAmazonProfileName(record.amazonProfileAccountInfoNames)
              }}
            </template>
            <template v-if="column.name == 'invitationAcceptedAt'">
              {{
                record.invitationAcceptedAt
                  ? moment(record.invitationAcceptedAt)
                    .tz(timeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
                  : '--'
              }}
            </template>
            <template v-if="column.name == 'campaignUpdatedAt'">
              {{
                record.campaignUpdatedAt
                  ? moment(record.campaignUpdatedAt)
                    .tz(timeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
                  : '--'
              }}
            </template>
            <template v-if="column.name == 'lastReportSyncSuccessAt'">
              {{
                record.lastReportSyncSuccessAt
                  ? moment(record.lastReportSyncSuccessAt)
                    .tz(timeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
                  : '--'
              }}
            </template>
            <template v-if="column.name == 'artemisAdsAccount' && activeTab == '2'">
              {{ record.sellerEmail || record.artemisAdsAccount || '--' }}
            </template>
            <template v-if="column.name == 'syncStatus' || (column.name == 'status' && activeTab == '2')">
              {{ formatUpdateStatus(record, column.name === 'syncStatus' ? 'syncStatus' : 'status') }}
            </template>
            <template v-if="column.name == 'status' && activeTab != '2'">
              {{ record.status || '--' }}
            </template>
            <template v-if="column.name == 'brandCcStatus'">
              {{ record.brandCcStatus || '--' }}
            </template>
            <template v-if="column.name == 'requestedBrandName'">
              {{ record.requestedBrandName
              }}{{
                record.hasDuplicateRequestedBrandName
                  ? ` (${record.amazonName})`
                  : ''
              }}
            </template>
            <template v-if="column.name == 'lastSyncTime'">
              {{
                record.lastSyncTime
                  ? moment(record.lastSyncTime)
                    .tz(timeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
                  : '--'
              }}
            </template>
            <template v-if="column.name == 'confirmedBrandName'">
              {{ record.confirmedBrandName
              }}{{
                record.hasDuplicateConfirmedBrandName
                  ? ` (${record.amazonName})`
                  : ''
              }}
            </template>
            <template v-if="column.name == 'action'">
              <div>
                <a-button
                  v-if="activeTab == '2'"
                  type="link"
                  class="campaign-update-link"
                  
                  :disabled="isReportSyncLoading(record, 'Brand')"
                  @click="updateCampaignReport(record,'Campaign')"
                >
                  UPDATE CAMPAIGN
                </a-button>
                <a-button
                  v-if="activeTab == '2'"
                  type="link"
                  class="campaign-update-link"
                 
                  :disabled="isReportSyncLoading(record, 'Campaign')"
                  @click="updateCampaignReport(record,'Brand')"
                >
                  UPDATE REPORT
                </a-button>
                <a-button type="primary" size="small" @click="confirm(record)" v-else-if="
                  record.status == 'pending' ||
                  record.brandCcStatus == 'pending'
                ">Confirm</a-button>
                 <a-button type="primary" size="small" @click="refreshItem(record)" 
                v-else-if="
                  record.status != 'pending' &&
                  record.brandCcStatus != 'pending' && activeTab == '1'
                "
                 >
                  更新
                 </a-button>
              </div>
            </template>
          </template>
        </artmisads-table>
      </div>
    </div>
    <div class="container" v-if="activeTab=='3'">
      <a-spin :spinning="loading">
        <div class="modal-content">
        <div style="margin-bottom: 12px;">
          输入cookie:
        </div>
        <a-textarea
      v-model:value="textarea"
      placeholder="请输入cookie"
      :auto-size="{ minRows: 2, maxRows: 5 }"
      style="margin-bottom: 12px;"
    />
      </div>
      <div class="modal-footer" style="margin-bottom: 12px;">
        <div style="margin-bottom: 12px;">
        <a-button type="primary" @click="handleSave" :disabled="!textarea">保存</a-button>
        </div>
         <div >
         <a-button @click="handleVerify" >验证</a-button>
      </div>
      </div>
      
      <div>
         <a-textarea
          v-model:value="responseText"
         placeholder="验证结果"
          :disabled="true"
        :auto-size="{ minRows: 2, maxRows: 5 }"
        />
      </div>
      </a-spin>
    </div>
    <editModal ref="editModalRef" @refresh="onRefresh" />
    <!-- <refreshModal ref="refreshModalRef" @refresh="onRefresh" /> -->
  </div>
</template>
<script setup lang="jsx">
import editModal from './editModal.vue'

import { ref, reactive, computed } from 'vue'
import breadcrumbs from '../../breadcrumbs.vue'
import { creatorConnectionsApi } from '@/server/operator/creatorConnections'
import moment from 'moment'
import { message, Modal } from 'ant-design-vue'
import { COUNTRY_TIME_TZ } from '~/contants/common'
import { useUserInfoStore } from '@/storeData'
import { countBrandNames } from '~/utils'
const textarea = ref('')
const responseText = ref('')
const loading = ref(false)
const handleSave=()=>{
 loading.value = true
  creatorConnectionsApi.ccConfigeTextUpdate(
   
      textarea.value,
   
  ).then(res=>{
    if(res.success){
      message.success('刷新成功')
    } else {
      message.error('刷新失败')
    }
  }).finally(()=>{
    loading.value = false
  })
}
const handleVerify=()=>{
    loading.value = true
    creatorConnectionsApi.ccConfigeTextCheck(
      
    ).then(res=>{
      if(res.success){
        if(res.data){
          responseText.value = '验证成功'
        }else{
          responseText.value = '验证失败'
        }
      } else {
        message.error('验证失败')
      }
    }).finally(()=>{
      loading.value = false
    })
}
const editModalRef = ref(null)
const refreshModalRef = ref(null)
const user = useUserInfoStore()
const breadcrumbsData = {
  title: 'Amazon CC Authorization',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/manualPayments',
    },
    {
      name: 'Authorization Creator Connections',
      path: '/operator/operation/creatorConnections/index',
    },
  ],
}
const timeZone = computed(() => {
  const countryCode = user?.userInfo?.countryCode || 'US'
  const data = COUNTRY_TIME_TZ[countryCode]
  return data
})
const load = ref(false)
const activeTab = ref('0')
const programConfig = ref([
  {
    label: 'Amazon Seller Account',
    key: '0',
  },
  {
    label: 'Brands',
    key: '1',
  },
  {
    label: 'Reports',
    key: '2',
  },
  {
    label: '手动更新Cookie',
    key: '3',
  }
])

const params = ref({
  status: '',
  sellerName: '',
  amazonProfileAccountInfoName: '',
  brandName: '',
})
const dataList = ref([])
const columns = ref([
  {
    title: 'ArtemisAds Account',
    name: 'artemisAdsAccount',
    dataIndex: 'artemisAdsAccount',
  },
  {
    title: 'Amazon Seller Name',
    name: 'sellerName',
    dataIndex: 'sellerName',
  },
  {
    title: 'Amazon Profile Name',
    dataIndex: 'amazonProfileName',
    name: 'amazonProfileName',
  },
  {
    title: 'Request Date',
    dataIndex: 'invitationAcceptedAt',
    name: 'invitationAcceptedAt',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    name: 'status',
  },
  {
    title: 'Action',
    dataIndex: 'Action',
    name: 'action',
  },
])
const UPDATE_STATUS_LABELS = {
  update_completed: 'Update Completed',
  update_inprogress: 'Update In Progress',
  update_failed: 'Update Failed',
}

const formatUpdateStatus = (record, field = 'status') => {
  const raw = record?.[field]
  if (raw == null || raw === '') return '--'
  if (typeof raw === 'string') {
    return UPDATE_STATUS_LABELS[raw] || raw
  }
  if (typeof raw === 'object') {
    const priority = ['update_inprogress', 'update_failed', 'update_completed']
    for (const key of priority) {
      if (raw[key]) {
        return UPDATE_STATUS_LABELS[key] || key
      }
    }
    const activeKey = Object.keys(raw).find((key) => raw[key])
    return activeKey ? UPDATE_STATUS_LABELS[activeKey] || activeKey : '--'
  }
  return String(raw)
}

const reportSyncLoading = reactive({})

const getReportSyncLoadingKey = (record, type) =>
  `${record.campaignId || record.id}-${type}`

const isReportSyncLoading = (record, type) =>
  !!reportSyncLoading[getReportSyncLoadingKey(record, type)]

const updateCampaignReport = async (record, type) => {

 load.value=true
  try {
    let data = {}
    if (type == 'Campaign') {
      data = await creatorConnectionsApi.ccCampaignSync({
        campaignId: record.campaignId,
      })
    } else if (type == 'Brand') {
      data = await creatorConnectionsApi.ccBrandSync({
        campaignId: record.campaignId,
        force: true,
      })
    }
    if (data.success) {
      message.success('更新成功')
      getList()
    } else {
      message.error(data.message || '更新失败')
    }
  } catch {
    message.error('更新失败')
  } finally {
    load.value=false
  }
}

const refreshItem=async (record)=>{
//  console.log(record,'refreshItem')
//  return
  creatorConnectionsApi.retrySyncItem(
    {
      sellerId: record.sellerId,
      // marketplace: record.marketplace,
      confirmedBrandId: record.confirmedBrandId,
    }
  ).then(res=>{
    if(res.success){
      message.success('更新成功')
      getList()
    } else {
      message.error('更新失败')
    }
  }).finally(()=>{
   
  })
  // refreshModalRef.value.openModal('refresh',record)
}
const onTabChange = (key) => {
  activeTab.value = key
  params.value.brandName = ''
  if (key == '0') {
    columns.value = [
      {
        title: 'ArtemisAds Account',
        name: 'artemisAdsAccount',
        dataIndex: 'artemisAdsAccount',
      },
      {
        title: 'Amazon Seller Name',
        name: 'sellerName',
        dataIndex: 'sellerName',
      },
      {
        title: 'Amazon Profile Name',
        dataIndex: 'amazonProfileName',
        name: 'amazonProfileName',
      },
      {
        title: 'Request Date',
        dataIndex: 'invitationAcceptedAt',
        name: 'invitationAcceptedAt',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        name: 'status',
      },
      {
        title: 'Action',
        dataIndex: 'Action',
        name: 'action',
      },
    ]
  } else if (key == '1') {
    columns.value = [
      {
        title: 'ArtemisAds Account',
        name: 'artemisAdsAccount',
        dataIndex: 'artemisAdsAccount',
      },
      {
        title: 'Amazon Seller Name',
        name: 'sellerName',
        dataIndex: 'sellerName',
      },
      {
        title: 'Amazon Profile Name',
        dataIndex: 'amazonProfileAccountInfoName',
        name: 'amazonProfileAccountInfoName',
      },
      {
        title: 'Request Brand',
        dataIndex: 'requestedBrandName',
        name: 'requestedBrandName',
        width: 200,
      },
      {
        title: 'Confirm Brand',
        dataIndex: 'confirmedBrandName',
        name: 'confirmedBrandName',
        width: 200,
      },
       {
        title: '上次更新时间',
        dataIndex: 'lastSyncTime',
        name: 'lastSyncTime',
      },
      {
        title: '更新结果',
        dataIndex: 'syncStatus',
        name: 'syncStatus',
      },
      // {
      //   title: 'Request Date',
      //   dataIndex: 'invitationAcceptedAt',
      //   name: 'invitationAcceptedAt',
      // },
      {
        title: 'Status',
        dataIndex: 'brandCcStatus',
        name: 'brandCcStatus',
      },
      {
        title: 'Action',
        dataIndex: 'Action',
        name: 'action',
      },
    ]
  } else if (key == '2') {
    columns.value = [
      {
        title: 'Campaign',
        name: 'campaignName',
        dataIndex: 'campaignName',
        width: 220,
      },
      {
        title: 'Brand',
        name: 'brandName',
        dataIndex: 'brandName',
        width: 160,
      },
      {
        title: 'Amazon Seller Name',
        name: 'sellerName',
        dataIndex: 'sellerName',
        width: 180,
      },
      {
        title: 'ArtemisAds Account',
        name: 'artemisAdsAccount',
        dataIndex: 'artemisAdsAccount',
        width: 220,
      },
      {
        title: 'Campaign Last Update Time',
        name: 'campaignUpdatedAt',
        dataIndex: 'campaignUpdatedAt',
        width: 180,
      },
      {
        title: 'Report Last Update Time',
        name: 'lastReportSyncSuccessAt',
        dataIndex: 'lastReportSyncSuccessAt',
        width: 180,
      },
      {
        title: 'Status',
        name: 'reportSyncStatus',
        dataIndex: 'reportSyncStatus',
        width: 160,
      },
      {
        title: 'Action',
        name: 'action',
        dataIndex: 'action',
        width: 120,
      },
    ]
  }
  if (key == '3') {
    return
  }
  onReset()
}
const onChangePage = (data) => {
  const { current, pageSize } = data

  pagination.current = current
  pagination.pageSize = pageSize

  // newParams.page = current
  // newParams.size = pageSize
  getList()
}
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,

  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const keywords = ref('')
const status = ref('')
const onSearchSellerName = () => {
  params.value.nameKeyword = keywords.value
  onSearch()
}
const onSearchStatus = () => {
  params.value.status = status.value
  onSearch()
}
const onSearchProfileName = () => {
  pagination.current = 1
  onSearch()
}
const onRefresh = () => {
  pagination.current = 1

  getList()
}
const refreshAll=()=>{
  creatorConnectionsApi.retrySyncAll(
    
  ).then(res=>{
    if(res.success){
      message.success('更新成功')
      getList()
    } else {
      message.error('更新失败')
    }
  }).finally(()=>{
   
  })
}
const onSearch = () => {
  pagination.current = 1
  pagination.pageSize = 10
  getList()
}
const onReset = () => {
  params.value.status = ''
  params.value.sellerName = ''
  params.value.amazonProfileAccountInfoName = ''
  params.value.brandName = ''
  pagination.current = 1
  pagination.pageSize = 10
  onSearch()
}
const getList = async () => {
  load.value = true
  let data
  const paramsObj = {
    page: pagination.current,
    size: pagination.pageSize,
    ...params.value
  }
  if (activeTab.value === '0') {
    data = await creatorConnectionsApi.getSellerConnections(paramsObj)
  } else if (activeTab.value === '2') {
    data = await creatorConnectionsApi.getCampaignReportList(paramsObj)
  } else {
    data = await creatorConnectionsApi.getBrandConnections(paramsObj)
  }
  if (data.success) {
    dataList.value = data.data.data

    if (activeTab.value == '1') {
      const requestedBrandNameCount = countBrandNames(
        data.data.data,
        'requestedBrandName',
      )
      const confirmedBrandNameCount = countBrandNames(
        data.data.data,
        'confirmedBrandName',
      )

      dataList.value = data.data?.data?.map((brand) => ({
        ...brand,
        hasDuplicateRequestedBrandName:
          brand.requestedBrandName &&
          requestedBrandNameCount[brand.requestedBrandName] > 1,
        hasDuplicateConfirmedBrandName:
          brand.confirmedBrandName &&
          confirmedBrandNameCount[brand.confirmedBrandName] > 1,
      }))
    }

    pagination.total = data.data.total


  } else {
    message.error(data.message)
    dataList.value = []
    pagination.total = 0
  }
  load.value = false
}
const returnAmazonProfileName = (nameArr) => {
  if (nameArr?.length > 0 && Array.isArray(nameArr)) {
    return nameArr.join(',')
  }
}
const confirm = async (record) => {
  if (activeTab.value == '0') {
    Modal.confirm({
      title: 'Are you sure you want to submit?',
      okText: 'Yes',
      okType: 'danger',
      onOk: () => {
        creatorConnectionsApi
          .authorizeConnection({
            id: record.id,
          })
          .then((res) => {
            if (res.success) {
              message.success('success')
              getList()
            } else {
              message.error(res.error)
            }
          })
      },
      onCancel: () => {
        // 取消提交
      },
    })
  } else {
    editModalRef.value.openModal(activeTab.value, record)
  }
}
// setTimeout(() => {
//   editModalRef.value.openModal()
// }, 500)
getList()
</script>
<style scoped lang="less">
.creatorConnections {
  padding: 20px;

  .container {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
  }

  .table-container {
    margin-top: 20px;
  }

  .search {
    display: flex;
    align-items: center;
  }

  .search-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .search-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 12px;
    gap: 12px;
  }

  .seller-name {
    color: var(--dark-1);
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.4px;
    line-height: 20px;
  }

  .seller-email {
    font-weight: 500;
    font-size: 12px;
    color: var(--dark-2);
    letter-spacing: 0.3px;
    line-height: 16px;
    padding: 10px 0;
  }

  .campaign-update-link {
    padding: 0;
    color: var(--primary, #6b4ce6);
    font-weight: 500;
  }
}
</style>
